/**
 * @fileoverview POST handler for the "/engagement/report_builder_2/:app_group_id/new_report" endpoint
 */

import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2AppGroupIdNewReportCacheKeys } from "./constants";
import type {
  EngagementReportBuilder2AppGroupIdNewReportResult,
  PostEngagementReportBuilder2AppGroupIdNewReportProps,
} from "./types";

function toSnakeCase(props: PostEngagementReportBuilder2AppGroupIdNewReportProps) {
  return {
    end_date: props.endDate,
    exclude_archived: props.excludeArchived,
    name: props.name,
    primary_dimension: props.primaryDimension,
    secondary_dimension: props.secondaryDimension,
    start_date: props.startDate,
    tertiary_dimension: props.tertiaryDimension,
    time_interval: props.timeInterval,
    date_range_type: props.dateRangeType,
    time_granularity: props.timeGranularity,
    time_value: props.timeValue,
    selected_kpis_as_json: props.selectedKpisAsJson,
    campaign_ids: props.campaignIds,
    channels: props.channels,
    report_tags: props.reportTags,
    segment_ids: props.segmentIds,
    workflow_ids: props.workflowIds,
    automatic_selection_criteria: !props.automaticSelectionCriteria
      ? undefined
      : {
          automatic_selection_tags_any: props.automaticSelectionCriteria.automaticSelectionTagsAny,
          automatic_selection_tags_all: props.automaticSelectionCriteria.automaticSelectionTagsAll,
          automatic_selection_name_contains: props.automaticSelectionCriteria.automaticSelectionNameContains,
          automatic_selection_name_not_contains: props.automaticSelectionCriteria.automaticSelectionNameNotContains,
          automatic_selection_last_sent_start_date:
            props.automaticSelectionCriteria.automaticSelectionLastSentStartDate,
          automatic_selection_last_sent_end_date:
            props.automaticSelectionCriteria.automaticSelectionLastSentEndDate,
          automatic_selection_message_types: props.automaticSelectionCriteria.automaticSelectionMessageTypes,
          automatic_selection_send_type: props.automaticSelectionCriteria.automaticSelectionSendType,
          automatic_selection_offerfit: props.automaticSelectionCriteria.automaticSelectionOfferfit,
          automatic_selection_message_prioritization:
            props.automaticSelectionCriteria.automaticSelectionMessagePrioritization,
        },
    include_deleted_canvas_steps: props.includeDeletedCanvasSteps,
    include_control_group_stats: props.includeControlGroupStats,
    tags: props.tags,
  };
}

export const postEngagementReportBuilder2AppGroupIdNewReport = reactQueryMutationAdapter(
  engagementReportBuilder2AppGroupIdNewReportCacheKeys,
  (
    props: PostEngagementReportBuilder2AppGroupIdNewReportProps
  ): Promise<EngagementReportBuilder2AppGroupIdNewReportResult> => {
    return fetch(
      `/engagement/report_builder_2/${props.appGroupId}/new_report`,
      "POST",
      toSnakeCase(props),
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
